module.exports = __webpack_public_path__ + "img/cover.b1e07fbf.png";